export const AssistancePage = () => {
  return (
    <div>Assistance page</div>
  )
}
